import React, { useEffect, useState } from "react";
import { Modal, Tooltip, Overlay } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface ImpactModalProps {
    successModalIsOpen: boolean;
    closeModal: () => void;
    message: string;
    username?: string;
    impact: number;
}

const ImpactModal: React.FC<ImpactModalProps> = ({
    successModalIsOpen,
    closeModal,
    username,
    message,
    impact,
}) => {
    const navigate = useNavigate();

    const copyToClipboard = (e: any, message: string) => {
        navigator.clipboard.writeText(message).then(() => {
            setTarget(e.target); // Set the target for the tooltip
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 2000); // Hide tooltip after 2 seconds
        });
    };

    const [showTooltip, setShowTooltip] = useState(false);
    const [target, setTarget] = useState(null);

    return (
        <div
            className="modal show"
            style={{ display: "block", position: "initial" }}
        >
            <Modal
                show={successModalIsOpen}
                onHide={() => {
                    closeModal();
                    window.location.reload();
                }}
            >
                <Modal.Header
                    className="modal-bg"
                    style={{ border: "none", textAlign: "center" }}
                >
                    <Modal.Title
                        style={{
                            flex: 1,
                        }}
                    >
                        You have made an impact!
                    </Modal.Title>
                    <button
                        className="btn-close"
                        onClick={() => {
                            closeModal();
                            window.location.reload();
                        }}
                        style={{
                            position: "absolute",
                            right: "3%",
                        }}
                    ></button>
                </Modal.Header>

                <Modal.Body
                    className="modal-bg"
                    style={{
                        border: "none",
                        padding: "unset",
                        paddingLeft: "var(--bs-modal-padding)",
                        paddingRight: "var(--bs-modal-padding)",
                    }}
                >
                    <div className="modal-body-container">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: message
                                    ?.replace(/\n/g, "<br/>")
                                    .replaceAll(
                                        "<i>",
                                        "<i style='font-style:italic'>"
                                    ),
                            }}
                        ></div>
                        <br />
                        <div className="share-invite">
                            <i>
                                Tell the world about your green travel choice by
                                sharing your offset impact on social media with
                                <b> #ReThinkTravel.</b> Let’s inspire others to
                                follow your lead! &nbsp;
                            </i>
                            <br />
                        </div>
                        <div
                            style={{
                                marginTop: "15px",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-evenly",
                            }}
                        >
                            <img
                                onClick={(e: any) => {
                                    const message = `Just offset my travel footprint! By doing this, I helped offset *${impact}* kg of CO₂e - a step towards a cleaner planet! Every journey can be sustainable!\n#ReThinkTravel\nhttps://rethinktravel.org`;
                                    copyToClipboard(e, message);
                                    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
                                        message
                                    )}`;
                                    window.open(whatsappURL, "_blank");
                                }}
                                style={{
                                    width: "25px",
                                    cursor: "pointer",
                                }}
                                src="/assets/images/icons/whatsapp-share.svg"
                                alt="WhatsApp Logo"
                                className="whatsapp-logo-inline"
                            />
                            <img
                                onClick={(e: any) => {
                                    const message = `Just offset my travel footprint! By doing this, I helped offset ${impact} kg of CO₂e - a step towards a cleaner planet! Every journey can be sustainable!\n#ReThinkTravel\nhttps://rethinktravel.org`;
                                    copyToClipboard(e, message);
                                }}
                                style={{
                                    width: "25px",
                                    cursor: "pointer",
                                }}
                                src="/assets/images/icons/copy-link-share.svg"
                                alt="Link logo"
                                className="whatsapp-logo-inline"
                            />
                            <img
                                onClick={(e: any) => {
                                    const message = `Just offset my travel footprint! By doing this, I helped offset ${impact} kg of CO₂e - a step towards a cleaner planet! Every journey can be sustainable!\n#ReThinkTravel\nhttps://rethinktravel.org`;
                                    copyToClipboard(e, message);
                                    const instagramDMUrl =
                                        "https://www.instagram.com/direct/inbox/";
                                    window.open(instagramDMUrl, "_blank");
                                }}
                                style={{
                                    width: "25px",
                                    cursor: "pointer",
                                }}
                                src="/assets/images/icons/instagram-share.svg"
                                alt="Link logo"
                                className="whatsapp-logo-inline"
                            />
                            <Overlay
                                target={target}
                                show={showTooltip}
                                placement="top"
                            >
                                {(props) => (
                                    <Tooltip id="copy-link-tooltip" {...props}>
                                        Link copied!
                                    </Tooltip>
                                )}
                            </Overlay>
                        </div>
                        <hr />
                        <div
                            style={{
                                marginTop: "15px",
                            }}
                        >
                            Visit&nbsp;
                            <a href="https://rethink.getre.org/rethink">
                                ReThink Sustainability
                            </a>{" "}
                            to transition towards a sustainable lifestyle with
                            free micro-actions.
                        </div>
                        <div
                            style={{
                                marginTop: "15px",
                            }}
                        >
                            <b style={{ fontStyle: "italic" }}>
                                <i>
                                    You will receive your impact report on the
                                    WhatsApp number you submitted within 24-72
                                    hours from <br />
                                    +91 89285 45695. Please save this number as
                                    <b>"ReThink"</b> to stay updated.
                                </i>
                            </b>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer
                    className="modal-bg"
                    style={{ border: "none" }}
                ></Modal.Footer>
            </Modal>
        </div>
    );
};

export default ImpactModal;
